import { convertInput, WfFormItem } from '../wf-form';
import WfInput from '../wf-input';
import { RefreshSvg } from '../wf-svg';

import './index.scss';

const STATIC_CAPTCHA =
  'data:image/png;base64,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';

interface CaptchaProps {
  imgSrc: string;
  isPreview?: boolean;
  loading: boolean;
  t: (key: string) => string;
  onRefresh: () => void;
}

function WfCaptcha(props: CaptchaProps) {
  const { imgSrc, isPreview, loading, t, onRefresh } = props;

  return (
    <WfFormItem
      id="captcha_text"
      label={t('webform.verification_code')}
      name="captcha_text"
      required={`${t('webform.verification_code')} ${t('webform.is_required')}`}
      style={{ display: 'flex' }}
      t={t}
      render={(props) => (
        <div className="wf-captcha-container">
          <WfInput
            style={{ flex: 1 }}
            placeholder={t('webform.verification_code.placeholder')}
            {...convertInput(props)}
          />

          <div className="wf-captcha-wrapper">
            <img
              className="wf-captcha-image"
              src={!isPreview ? imgSrc : STATIC_CAPTCHA}
              alt="Please click the refresh button"
            />

            <button
              className="wf-captcha-button"
              type="button"
              title={t('webform.verification_code.refresh_btn.title')}
              disabled={loading}
              onClick={onRefresh}
            >
              <RefreshSvg />
            </button>
          </div>
        </div>
      )}
    />
  );
}

export default WfCaptcha;
